import { piiFormModel } from 'components/FormFields/PII';

const { nameModel } = piiFormModel;

export default nameModel;
